<template>
  <div>
    <v-overlay
      color="white"
      opacity="0.9"
      absolute
      v-if="$store.state.momo.progress"
    >
      <center v-if="!$store.state.momo.requestPendding">
        <v-progress-circular
          class="d-block"
          color="green"
          size="50"
          width="4"
          indeterminate
        >
        </v-progress-circular>

        <p class="text-h5 m-2 black--text font-weight-light">
          Transaction in progress, <br />do not close this dialog or page
        </p>
      </center>
      <center v-else>
        <h4 v-if="network == 'MTN'" class="yellow--text font-weight-bold">
          Dial *170#
        </h4>
        <h4 v-if="network == 'MTN'" class="yellow--text font-weight-bold">
          Select 6 - My Wallet
        </h4>
        <h4 v-if="network == 'MTN'" class="yellow--text font-weight-bold">
          Select 3 - My Approvals
        </h4>

        <v-progress-circular
          class="d-block"
          color="green"
          size="30"
          width="4"
          indeterminate
        >
        </v-progress-circular>

        <p class="text-h5 m-2 black--text font-weight-light">
          Waiting for payment authorisation, <br />
          transaction will continue automatically
        </p>

        <v-btn
          class="d-block mt-5"
          rounded
          outlined
          color="red"
          v-if="business.country.code === 'RW'"
          @click="$store.state.momo.progress = false"
          >Cancel
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </center>
    </v-overlay>
    <v-card-text v-if="business.country.code === 'SL'">
      <center>
        <v-avatar size="120" rounded>
          <v-img
            src="https://built-storage.ams3.cdn.digitaloceanspaces.com/Built/logo_orange.svg"
            contain
          ></v-img>
        </v-avatar>
      </center>
      <h2 class="text-center mt-4">Pay with Orange money</h2>
      <p class="text-h4 text-center font-weight-light mb-0">
        {{ resolvedPayableAmount | toMoney | currency_symbol }}
      </p>
      <small class="d-block w-100 text-center">Amount</small>

      <v-text-field
        v-if="isSubscriptionMomoCheckout"
        class="mt-4"
        placeholder="232xxxxxxxxx"
        type="tel"
        label="Orange Money number"
        v-model="numberSL"
        outlined
        :disabled="$store.state.momo.progress"
      ></v-text-field>

      <v-alert color="orange lighten-5 orange--text" class="mt-5">
        <strong
          >How to get the payment code when you get to the payment page:</strong
        >
        <ul class="mt-3">
          <li>Dial *144#</li>
          <li>Select Make Payment</li>
          <li>Select Online Payment</li>
          <li>Confirm your PIN</li>
          <li>The payment security code would be sent to your phone</li>
        </ul>
      </v-alert>

      <v-btn
        :loading="progress"
        @click="getOrangeCheckout"
        color="orange darken-2"
        x-large
        rounded
        block
        dark
        depressed
        >Pay Now!</v-btn
      >
    </v-card-text>

    <v-card-text v-if="business.country.code === 'GH'">
      <v-sheet
        v-if="costBreakdown"
        color="grey lighten-5"
        rounded="lg"
        elevation="0"
        class="pa-4 mb-4 text-left plan-pricing-sheet"
      >
        <div class="d-flex justify-space-between py-1 body-2">
          <span>Subscription base (before taxes)</span>
          <strong>{{ costBreakdown.base | toMoney | currency_symbol }}</strong>
        </div>
        <div
          class="d-flex justify-space-between py-1 grey--text text--darken-1 caption"
        >
          <span>VAT (15% of base)</span>
          <span>{{ costBreakdown.vat | toMoney | currency_symbol }}</span>
        </div>
        <div
          class="d-flex justify-space-between py-1 grey--text text--darken-1 caption"
        >
          <span>NHIL (2.5% of base)</span>
          <span>{{ costBreakdown.nhil | toMoney | currency_symbol }}</span>
        </div>
        <div
          class="d-flex justify-space-between py-1 grey--text text--darken-1 caption"
        >
          <span>GETFund levy (2.5% of base)</span>
          <span>{{ costBreakdown.getfund | toMoney | currency_symbol }}</span>
        </div>
        <v-divider class="my-2"></v-divider>
        <div
          class="d-flex justify-space-between text-h6 green--text font-weight-bold"
        >
          <span>Total to pay</span>
          <span>{{ costBreakdown.total | toMoney | currency_symbol }}</span>
        </div>
      </v-sheet>

      <v-stepper class="p-0" v-model="step" style="box-shadow: none !important">
        <v-stepper-items>
          <v-stepper-content step="1" class="p-0">
            <v-row dense>
              <v-col cols="12" class="mt-2">
                <p class="text-center text-h5 font-weight-bold">
                  Pay {{ resolvedPayableAmount | toMoney | currency_symbol }}
                </p>

                <v-list
                  class="grey lighten-5 pa-4"
                  style="
                    border-radius: 15px !important;
                    transition: 0.3s ease-in-out;
                  "
                >
                  <center>
                    <v-icon color="green" x-large>mdi-cellphone-text</v-icon>
                    <p class="text-center text-h5 font-weight-light">
                      Select your network
                    </p>
                  </center>

                  <v-list-item
                    :class="
                      networkItem.value === network
                        ? 'green lighten-5 green--text ma-2'
                        : 'white ma-2'
                    "
                    style="
                      border-radius: 15px !important;
                      transition: 0.4s ease-in-out;
                    "
                    v-for="networkItem in networks"
                    :key="networkItem.value"
                    @click="network = networkItem.value"
                  >
                    <v-list-item-avatar rounded style="border-radius: 15px">
                      <v-img
                        :src="'/img/' + networkItem.value + '.jpeg'"
                      ></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ networkItem.text }}</v-list-item-title
                      >
                    </v-list-item-content>
                    <v-list-item-action-text>
                      <v-icon v-if="networkItem.value === network" color="green"
                        >mdi-check-circle</v-icon
                      >
                      <v-icon v-else x-small color="grey"
                        >mdi-chevron-right</v-icon
                      >
                    </v-list-item-action-text>
                  </v-list-item>
                </v-list>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  placeholder="024xxxxxxx"
                  type="tel"
                  v-if="network"
                  label="Phone Number"
                  v-model="number"
                  autofocus
                  outlined
                  :disabled="$store.state.momo.progress"
                ></v-text-field>
              </v-col>

              <v-col class="12">
                <v-alert
                  v-if="false"
                  type="error"
                  color="red lighten-5 red--text"
                  class="font-weight-light"
                >
                  The amount has exceeded the limit, you cannot send more than
                  GHS5,000.
                </v-alert>

                <v-btn
                  depressed
                  block
                  dark
                  color="blue darken-4"
                  rounded
                  :loading="progress"
                  x-large
                  v-if="validMOMO && !$store.state.momo.requestPendding"
                  @click="pay"
                  >Pay Now!
                </v-btn>
              </v-col>
            </v-row>
          </v-stepper-content>
          <v-stepper-content step="2" class="p-0">
            <v-row dense>
              <v-col cols="12" sm="12" class="mx-auto text-center">
                <h4>
                  Please enter OTP code sent to
                  <strong
                    >******{{ number.substring(number.length, 6) }}</strong
                  >
                  to continue
                </h4>
                <span
                  >Did not get code?
                  <v-btn
                    text
                    color="blue"
                    x-small
                    rounded
                    @click="
                      sendOTP();
                      new_request = !new_request;
                    "
                    :loading="progress"
                    >request new code</v-btn
                  >
                  or
                  <v-btn text color="blue" x-small @click="step = 1"
                    >change number</v-btn
                  >
                </span>
                <v-alert
                  v-if="new_request && !progress"
                  type="success"
                  color="green lighten-5 green--text"
                  dismissible
                  class="p-1"
                >
                  <h5>New OTP Sent</h5>
                </v-alert>
              </v-col>
              <v-col cols="12" sm="8" class="mx-auto text-center">
                <v-progress-circular
                  size="40"
                  color="blue darken-4"
                  indeterminate
                  v-if="verifyingOTP"
                ></v-progress-circular>
                <v-otp-input
                  v-else
                  ref="otpInput"
                  input-classes="form-control border"
                  separator="&nbsp;"
                  :num-inputs="6"
                  :should-auto-focus="true"
                  :is-input-num="true"
                  @on-change="handleOTPChange"
                  @on-complete="handleOTPComplete"
                />
              </v-col>
            </v-row>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card-text>

    <v-card-text v-if="business.country.code === 'KE'">
      <center>
        <h1 class="font-weight-black mb-0 pb-0">
          {{ resolvedPayableAmount | toMoney | currency_symbol }}
        </h1>
        <small class="text-muted mb-3">Amount Due</small>
      </center>

      <v-form ref="KEcheckoutForm">
        <v-text-field
          placeholder="254xxxxxxxxx"
          type="tel"
          label="Phone Number"
          v-model="numberKE"
          :rules="$store.state.required_rules"
          outlined
          :disabled="$store.state.momo.progress"
        ></v-text-field>

        <v-btn
          depressed
          block
          dark
          color="blue darken-4"
          rounded
          :loading="progress"
          x-large
          @click="KEMOMOpay"
          >Pay Now!
        </v-btn>
      </v-form>
    </v-card-text>
    <v-card-text v-if="business.country.code === 'RW'">
      <center>
        <h1 class="font-weight-black mb-0 pb-0">
          {{ resolvedPayableAmount | toMoney | currency_symbol }}
        </h1>
        <small class="text-muted mb-3">Amount Due</small>
      </center>

      <v-form ref="RWcheckoutForm">
        <v-text-field
          placeholder="07########"
          type="tel"
          label="Phone Number"
          v-model="numberKE"
          :rules="$store.state.required_rules"
          outlined
          :disabled="$store.state.momo.progress"
        ></v-text-field>

        <v-btn
          depressed
          block
          dark
          color="blue darken-4"
          rounded
          :loading="progress"
          x-large
          @click="RWMOMOpay"
          >Pay Now!
        </v-btn>
      </v-form>
    </v-card-text>

    <v-dialog persistent width="500" v-model="$store.state.momo.failed">
      <v-card>
        <v-card-title class="font-weight-light">
          Transaction failed
        </v-card-title>
        <v-card-text>
          <h4 class="font-weight-light">{{ $store.state.momo.message }}</h4>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="red"
            block
            depressed
            rounded
            dark
            x-large
            @click="
              $store.state.momo.requestPendding = false;
              $store.state.momo.progress = false;
              $store.state.momo.failed = false;
            "
            >{{ $t("main.ok") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import store from "@/store";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Checkout",
  props: [
    "amount",
    "account_id",
    "record_type",
    "record_id",
    "metaData",
    "isEligibleForDiscount",
    "discountedPrice",
    /** Ghana subscription: { base, vat, nhil, getfund, total } for MoMo checkout copy. */
    "costBreakdown",
    "subscriptionCoupon",
    "currentPlanId",
    "changeCurrentPlanId",
  ],

  data() {
    return {
      userOTP: null,
      verifyingOTP: false,
      new_request: false,
      otp: null,
      step: 1,
      requestPendding: false,
      network: null,
      number: "",
      progress: false,
      ref: "",
      failed: false,
      failed_meesage: "",
      numberKE: "",
      numberSL: "",
      networks: [
        {
          text: "AirtelTigo",
          value: "AirtelTigo",
        },
        {
          text: "MTN",
          value: "MTN",
        },
        {
          text: "Vodafone",
          value: "VODAFONE",
        },
      ],

      numberPattern: [
        {
          network: "MTN",
          code: "024",
        },

        {
          network: "MTN",
          code: "055",
        },
        {
          network: "MTN",
          code: "054",
        },

        {
          network: "MTN",
          code: "059",
        },

        {
          network: "VODAFONE",
          code: "020",
        },

        {
          network: "VODAFONE",
          code: "050",
        },

        {
          network: "AIRTEL",
          code: "027",
        },

        {
          network: "AIRTEL",
          code: "057",
        },

        {
          network: "AIRTEL",
          code: "026",
        },
      ],
    };
  },
  watch: {
    complete() {
      this.step = 1;
      this.verifyingOTP = false;

      this.$emit("paymentComplete", {
        ref: this.ref,
        account_id: this.account_id,

        // eslint-disable-next-line no-undef
        amount: this.resolvedPayableAmount,
      });
    },
  },
  computed: {
    reference() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 10; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      let d = new Date();
      let timestamp = d.getTime();
      return "Subscription_" + timestamp + "" + text;
    },
    business() {
      return this.$store.state.user.current_business;
    },

    resolvedPayableAmount() {
      if (
        this.isEligibleForDiscount &&
        this.discountedPrice != null &&
        this.discountedPrice !== ""
      ) {
        const d = Number(this.discountedPrice);
        if (!Number.isNaN(d) && d >= 0) {
          return d;
        }
      }
      const a = Number(this.amount);
      return Number.isNaN(a) ? 0 : a;
    },

    complete() {
      return this.$store.state.momo.complete2;
    },

    validMOMO() {
      return this.network && this.number.length === 10 && !isNaN(this.number);
    },

    /**
     * @return {boolean}
     */
    NumberBelongsToNetwork() {
      let network = this.network;
      let code = this.number.substr(0, 3);

      const foundNetwork = this.numberPattern.find((item) => {
        return item.code === code && item.network === network;
      });

      return Boolean(foundNetwork);
    },

    selectedIcon() {
      return this.network
        ? "/img/" + this.network + ".jpeg"
        : "/img/cellphone-message.png";
    },

    isSubscriptionMomoCheckout() {
      return (
        typeof this.record_type === "string" &&
        this.record_type.indexOf("subscription-") === 0
      );
    },
  },
  methods: {
    subscriptionPlanNameFromRecordType() {
      if (typeof this.record_type !== "string") {
        return "";
      }
      const prefix = "subscription-";
      if (this.record_type.indexOf(prefix) !== 0) {
        return "";
      }
      return this.record_type.slice(prefix.length);
    },

    subscriptionPlanIdField(value) {
      if (value == null || value === "") {
        return "";
      }
      return String(value);
    },

    subscriptionApiNetwork() {
      const code =
        this.business && this.business.country && this.business.country.code
          ? this.business.country.code
          : "";
      if (code === "KE") {
        return "mpesa";
      }
      if (code === "RW") {
        return "MTN";
      }
      if (code === "SL") {
        return "orange_money";
      }
      if (code === "GH") {
        if (this.network === "AirtelTigo") {
          return "AIRTELTIGO";
        }
        if (this.network === "VODAFONE") {
          return "VODAFONE";
        }
        if (this.network === "MTN") {
          return "MTN";
        }
        return this.network ? String(this.network).toUpperCase() : "";
      }
      return "";
    },

    subscriptionMomoAccountNumber() {
      const code =
        this.business && this.business.country && this.business.country.code
          ? this.business.country.code
          : "";
      if (code === "GH") {
        return this.number;
      }
      if (code === "KE" || code === "RW") {
        return this.numberKE;
      }
      if (code === "SL") {
        return this.numberSL;
      }
      return "";
    },

    buildMomoSubscriptionBody() {
      return {
        network: this.subscriptionApiNetwork(),
        interval: Number(this.record_id) || 0,
        plan_name: this.subscriptionPlanNameFromRecordType(),
        account_number: String(this.subscriptionMomoAccountNumber() || ""),
        coupon:
          this.subscriptionCoupon != null
            ? String(this.subscriptionCoupon)
            : "",
        current_plan_id: this.subscriptionPlanIdField(this.currentPlanId),
        change_current_plan_id: this.subscriptionPlanIdField(
          this.changeCurrentPlanId,
        ),
      };
    },

    postInitMomoSubscription() {
      this.$store.state.momo.progress = true;

      axios
        .post("/init-momo-subscription", this.buildMomoSubscriptionBody())
        .then((res) => {
          const d = res.data || {};
          if (d.payment_url) {
            this.$store.state.momo.progress = false;
            this.progress = false;
            window.location.href = d.payment_url;
            return;
          }

          if (d.reference) {
            this.ref = d.reference;
            this.$store.state.momo.requestPendding = true;
            this.listenForAuth();
            return;
          }
          this.$store.state.momo.progress = false;
          this.$store.state.momo.message = d.msg || "Something went wrong";
          this.$store.state.momo.failed = true;
        })
        .catch((error) => {
          this.$store.state.momo.progress = false;
          this.$store.state.momo.message =
            error.response && error.response.status === 302
              ? error.response.data
              : "Something went wrong, please try again";
          this.$store.state.momo.failed = true;
        });
    },

    getOrangeCheckout() {
      this.progress = true;

      if (this.isSubscriptionMomoCheckout) {
        this.progress = false;
        if (!String(this.numberSL || "").trim()) {
          this.$store.state.momo.message =
            "Please enter your Orange Money phone number";
          this.$store.state.momo.failed = true;
          return;
        }
        this.postInitMomoSubscription();
        return;
      }

      const data = {
        amount: this.resolvedPayableAmount,
        account_id: this.account_id,
        record_type: this.record_type,
        record_id: this.record_id,
        reference: this.reference,
      };
      axios
        .post("/orange/init/checkout", data)
        .then((res) => {
          if (res.data && res.data.status == 201 && res.data.payment_url) {
            window.open(res.data.payment_url);
          }
          this.progress = false;
        })
        .catch((error) => {
          this.progress = false;
        });
    },

    KEMOMOpay() {
      if (this.$refs.KEcheckoutForm.validate()) {
        if (this.isSubscriptionMomoCheckout) {
          this.postInitMomoSubscription();
          return;
        }

        this.$store.state.momo.progress = true;

        let data = {
          phone_number: this.numberKE,
          amount: this.resolvedPayableAmount,
          account_number: this.numberKE,
          account_id: this.account_id,
          reference: this.reference,
          record_type: this.record_type,
          record_id: this.record_id,
          meta_data: this.metaData,
        };
        // const formData = new FormData();
        // formData.append("phone_number", this.numberKE);
        // formData.append(
        //     "amount",
        //     this.isEligibleForDiscount ? this.discountedPrice : this.amount
        // );
        // formData.append("account_number", this.numberKE);
        // formData.append("account_id", this.account_id);
        // formData.append("reference", this.reference);
        //
        // if (this.record_id && this.record_type) {
        //   formData.append("record_type", this.record_type);
        //   formData.append("record_id", this.record_id);
        // }
        //
        // if (this.metaData) {
        //   formData.append("meta_data", this.metaData);
        // }

        let oldULR = "/ke/init/mobile-checkout";
        oldULR = "/collection/mpesa";
        axios
          .post(oldULR, data)
          .then((res) => {
            const ch = "TANDA-MPESA_" + res.data.id;

            if (res.data.status === "000001") {
              this.ref = res.data.id;

              this.listenForAuth(ch);
              this.$store.state.momo.requestPendding = true;
            } else {
              this.$store.state.momo.progress = false;
              this.$store.state.momo.message = res.data.message;
              this.$store.state.momo.failed = true;
            }
          })
          .catch((error) => {
            this.$store.state.momo.progress = false;
            this.$store.state.momo.message =
              error.response.status === 302
                ? error.response.data
                : "Something went wrong, please try again";
            this.$store.state.momo.failed = true;
          });
      }
    },

    RWMOMOpay() {
      if (this.$refs.RWcheckoutForm.validate()) {
        if (this.isSubscriptionMomoCheckout) {
          this.postInitMomoSubscription();
          return;
        }

        this.$store.state.momo.progress = true;

        const formData = new FormData();
        formData.append("phone_number", this.numberKE);
        formData.append("amount", this.resolvedPayableAmount);
        formData.append("account_number", this.numberKE);
        formData.append("account_id", this.account_id);
        formData.append("reference", this.reference);

        if (this.record_id && this.record_type) {
          formData.append("record_type", this.record_type);
          formData.append("record_id", this.record_id);
        }

        if (this.metaData) {
          formData.append("meta_data", this.metaData);
        }

        const URL = "/rw/init/mobile-checkout";

        axios
          .post(URL, formData)
          .then((res) => {
            const ch = "PAYPACK_" + res.data.ref;

            if (res.data.status.toUpperCase() === "PENDING") {
              this.ref = res.data.ref;

              this.listenForAuth(ch);

              this.$store.state.momo.requestPendding = true;
            } else {
              this.$store.state.momo.progress = false;
              this.$store.state.momo.message = res.data.message;
              this.$store.state.momo.failed = true;
            }
          })
          .catch((error) => {
            this.$store.state.momo.progress = false;
            this.$store.state.momo.message =
              error.response.status === 302
                ? error.response.data
                : "Something went wrong, please try again";
            this.$store.state.momo.failed = true;
          });
      }
    },
    handleOTPChange() {},

    handleOTPComplete(otp) {
      this.userOTP = otp;
      this.veirifyOTP();
    },

    handleClearOTP() {},

    veirifyOTP() {
      this.verifyingOTP = true;
      const formData = new FormData();
      formData.append("id", this.otp.id);
      formData.append("phone_number", this.otp.recipient_number);
      axios
        .post("/otp/verify/" + this.userOTP, formData)
        .then((res) => {
          this.verifyingOTP = false;
          this.otp = res.data;
          if (res.data.status) {
            this.pay();
          } else {
            this.$store.state.momo.message = res.data.message;
            this.$store.state.momo.failed = true;
          }
        })
        .catch((error) => {
          this.verifyingOTP = false;
          this.$store.state.momo.message =
            "Something went wrong, could not verify the OTP code;";
          this.$store.state.momo.failed = true;
        });
    },

    sendOTP() {
      this.progress = true;

      if (this.number) {
        axios
          .get("/otp/code/" + this.number)
          .then((res) => {
            this.otp = res.data;

            this.progress = false;

            if (res.data.status) {
              this.step = 2;
            } else {
              this.$store.state.momo.message = res.data.message;
              this.$store.state.momo.failed = true;
            }
          })
          .catch((error) => {
            this.progress = false;

            this.$store.state.momo.message =
              "Something went wrong, could not send OTP";
            this.$store.state.momo.failed = true;
          });
      }
    },

    pay() {
      if (this.isSubscriptionMomoCheckout) {
        this.postInitMomoSubscription();
        return;
      }

      this.$store.state.momo.progress = true;

      let formData = new FormData();

      formData.append("network", this.network);
      formData.append("account_number", this.number);
      formData.append("amount", this.resolvedPayableAmount);
      formData.append("account_id", this.account_id);

      if (this.record_id && this.record_type) {
        formData.append("record_type", this.record_type);
        formData.append("record_id", this.record_id);
      }

      //formData.append('otp_id',this.otp.id);

      axios
        .post("/nsano/debit", formData)
        .then((res) => {
          this.ref = res.data.reference;
          this.$store.state.momo.requestPendding = true;
          this.listenForAuth();
        })
        .catch((error) => {
          this.$store.state.momo.progress = false;
          this.$store.state.momo.message =
            error.response.status === 302
              ? error.response.data
              : "Something went wrong, please try again";
          this.$store.state.momo.failed = true;
        });
    },

    listenForAuth(ch = null) {
      const channel = ch ? ch : `debitconfirmation_${this.ref}`;

      this.sockets.subscribe(channel, (e) => {
        let message = e;
        if (message.data.code !== "00") {
          this.$store.state.momo.message =
            message.data.system_msg.length > 0
              ? message.data.system_msg
              : message.data.error_message;
          this.$store.state.momo.failed = true;
        } else {
          this.$store.state.momo.progress = false;
          this.$store.state.momo.complete2 = !this.$store.state.momo.complete2;
          this.$store.state.momo.requestPendding = false;
        }
      });
    },
  },
};
</script>

<style scoped>
.plan-pricing-sheet {
  border: 1px solid rgba(0, 0, 0, 0.06);
}
</style>
